import styled from 'styled-components'
import { Alert as AntdAlert } from 'antd'

export const Alert = styled(AntdAlert)`
  & .ant-alert-message {
    color: #111;
  }
`
